import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权
import { getAccountId, fetchDomain } from '@/api/login'
import Vue from 'vue'
const BASE_URL = '/user'
const whiteList = ['/404'] // 不重定向白名单

const judgePermission = (path, whiteList) => {
  let isPermitted = false
  whiteList.map(str => {
    str = str.replace(/([^*])\*([^*])/g, '$1[^\/]*$2')
    str = str.replace(/([^*])\*$/g, '$1[^\/]*')
    str = str.replace('**/', '([^\/]+\/)*')
    str = '^' + str + '$'
    if (path.match(new RegExp(str))) {
      isPermitted = true
      return true
    }
  })
  return isPermitted
}

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
    return
  }
  if (!store.getters.hasGotRouters) {
    getAccountId().then(response => {
      store.commit('SET_ROLES', response.data.currentCategory)
      store.commit('SET_NAME', response.data.displayName)
      store.commit('SET_AVATAR', response.data.avatarUrl)
      store.commit('SET_CURRENTCATEGORY', response.data.currentCategory)
    }).then(()=>{
      store.dispatch('permission/GenerateRoutes').then(() => {
        // 动态加载后台配置菜单对应的路由
        router.addRoutes(store.getters.addRouters)
        // console.log("store.getters.addRouters",store.getters.addRouters)
        next({ ...to, replace: true })
      })
    })
  } else {
    if (to.path !== '/' && window.__POWERED_BY_QIANKUN__ && to.matched.length === 0) {
      next()
      Vue.prototype.mainProps.childRouterNoMatch(BASE_URL, to.fullPath)
      return
    }
    // 路由跳转前调用当前用户信息接口，判断是否登录超时等
    getAccountId().finally(() => {
      NProgress.start()
      next()
      NProgress.done()
    })
  }

  // store.dispatch('GetInfo').then()
  // if (getToken()) {
  //   if (to.path === '/' || to.path === '/login') {
  //     next('/dashboard')
  //     NProgress.done()
  //   } else {
  //     // if (!store.getters.roles || store.getters.roles.length === 0) {
  //     //   store.dispatch('GetInfo').then(res => { // 拉取用户信息
  //     next()
  //     NProgress.done()
  //     //   }).catch(() => {
  //     //     store.dispatch('FedLogOut').then(() => {
  //     //       Message.error('验证失败,请重新登录')
  //     //       next({ path: '/login' })
  //     //     })
  //     //   })
  //     // } else {
  //     //   next()
  //     // }
  //   }
  // } else {
  //   if (judgePermission(to.path, whiteList)) {
  //     next()
  //   } else {
  //     // next('/login')
  //     // NProgress.done()
  //     window.location.href = 'http://dev.suaa.svwsx.cn'
  //     // fetchDomain().then(response => {
  //     //   window.location.href = response.data.UAA
  //     // }).catch(() => {
  //     //   next('/404')
  //     // })
  //   }
  // }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js